import QrPage from '../pages/QrPage'
import OrderReportPage from '../pages/reports/OrderReportPage'
import ArqueoReportPage from '../pages/reports/ArqueoReportPage'
import SalesReportPage from '../pages/reports/SalesReportPage'

const routes = [
    {
        name: 'QrPage',
        path: '/qr',
        component: QrPage,
    },

    {
        name: 'SalesReportPage',
        path: '/sales/report',
        component: SalesReportPage,
        meta: {
            requiresAuth: true,
            permission: "REPORT_SALES"
        }
    },

    {
        name: 'OrderReportPage',
        path: '/order/report',
        component: OrderReportPage,
        meta: {
            requiresAuth: true,
            permission: "REPORT_ORDER"
        }
    },
    {
        name: 'ArqueoReportPage',
        path: '/arqueo/report',
        component: ArqueoReportPage,
        meta: {
            requiresAuth: true,
            permission: "REPORT_ORDER"
        }
    },

]

export default routes;
